cb.define([], function (common) {
  var ST_st_storechecklist_FilterVM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      viewmodel.on('afterInit', function () {
        var currentDate = new Date().format('yyyy-MM-dd');
        viewmodel.get('vouchdate').getFromModel().setValue(getFirstDayOfCurrentMonth());
        viewmodel.get('vouchdate').getToModel().setValue(currentDate);

        //根据当前用户有权限的门店进行仓库过滤
        viewmodel.get("warehouse_name").getFromModel().on('beforeBrowse', function (data) {
          var promise = new cb.promise();
          var store_ids = [];
          var userStores = cb.rest.AppContext.user.userStores;

          if (userStores != null && userStores != "" && userStores.length != 0) {
            for (var i = 0; i < userStores.length; i++) {
              store_ids.push(userStores[i].store);
            }
          }

          if (store_ids != null && store_ids != "" && store_ids.length != 0) {
            var proxy = cb.rest.DynamicProxy.create({
              settle: {
                url: "/bill/ref/getWarehousesFromStores",
                method: "POST"
              }
            });
            var params = {
              storeIds: store_ids,
            };
            proxy.settle(params, (err, result) => {
              if (err) {
                cb.utils.alert(err.message, 'error');
              }

              if (result === undefined || result.length == 0) {
                cb.utils.alert("没有查询到仓库！", 'error');
              } else {
                var conditionWarehouse = {
                  "isExtend": true,
                  simpleVOs: []
                };
                //门店下的仓库
                conditionWarehouse.simpleVOs.push({
                  field: 'id',
                  op: 'in',
                  value1: result
                });
                //门店仓
                conditionWarehouse.simpleVOs.push({
                  field: 'wStore',
                  op: 'eq',
                  value1: true
                });

                viewmodel.get('warehouse_name').getFromModel().setFilter(conditionWarehouse);
                promise.resolve();
              }
            });
          } else {
            cb.utils.alert("无权限仓库！", 'error');
          }
          return promise;
        });


      });

      var getFirstDayOfCurrentMonth = function () {
        var firstDate = new Date();
        firstDate.setDate(1); //第一天
        return firstDate.format('yyyy-MM-dd');
      };


    }
  };
  try {
    module.exports = ST_st_storechecklist_FilterVM_Extend;
  } catch (error) {

  }
  return ST_st_storechecklist_FilterVM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storechecklist_FilterVM.Extend.js